import { useEffect, type ReactElement } from 'react'
// import dynamic from 'next/dynamic'
// import { useRouter } from 'next/router'
// import { CREATION_MODAL_QUERY_PARM } from '../new-safe/create/logic'
import { Grid } from '@mui/material'
import TotalAssetBalance from '@/components/dashboard/TotalAssetBalance/TotalAssetBalance'
import Assets from '@/components/dashboard/Assets/Assets'
import NoticeInheritance from '@/components/dashboard/NoticeInheritance/NoticeInheritance'
import PendingPayment from '@/components/dashboard/PendingPayment/PendingPayment'
import Apps from '@/components/dashboard/Apps/Apps'
// import useRecovery from '@/features/recovery/hooks/useRecovery'
// import { useIsRecoverySupported } from '@/features/recovery/hooks/useIsRecoverySupported'
// const RecoveryHeader = dynamic(() => import('@/features/recovery/components/RecoveryHeader'))
// const RecoveryWidget = dynamic(() => import('@/features/recovery/components/RecoveryWidget'))
import useDesktop from '@/hooks/useDesktop'
// import { getInheritorInfo } from '@/utils/api'

// import useInheritanceOfInheritor from '@/hooks/useInheritanceOfInheritor'
import useIsLoading from '@/hooks/useIsLoading'

// const CardContentPadding = styled(CardContent)(`
//   padding: 16px;
//   &:last-child {
//     padding-bottom: 16px;
//   }
// `)

const Dashboard = (): ReactElement => {
  const isDesktop = useDesktop()
  const { enableLoading, disableLoading } = useIsLoading()

  // const router = useRouter()
  // const { [CREATION_MODAL_QUERY_PARM]: showCreationModal = '' } = router.query

  // const supportsRecovery = useIsRecoverySupported()
  // const [recovery] = useRecovery()
  // const showRecoveryWidget = supportsRecovery && !recovery

  // const wallet = useWallet()
  // const chainInfo = useCurrentChain()

  // const inheritanceOfInheritor = useInheritanceOfInheritor()

  useEffect(() => {
    setTimeout(() => {
      disableLoading()
    }, 1000)
  }, [])

  // const chainId = useChainId()

  return (
    <>
      <Grid container spacing={1.5} height="100%" p={isDesktop ? '0' : '16px'}>
        <Grid item xs={12} lg={8}>
          <Grid container spacing={1.5}>
            {/* Overview */}
            <Grid item xs={12}>
              {/* <div style={{ width: '100%', height: '220px', background: '#1F2232', borderRadius: '6px' }}></div> */}
              <TotalAssetBalance />
            </Grid>
            {/* Notice of Inheritance */}
            {true && (
              <Grid item xs={12}>
                {/* <div style={{ width: '100%', height: '116px', background: '#1F2232', borderRadius: '6px' }}></div> */}
                <NoticeInheritance />
              </Grid>
            )}
            {/* Pending Payment */}
            {isDesktop && (
              <Grid item xs={12}>
                <PendingPayment />
              </Grid>
            )}
          </Grid>
        </Grid>
        {/* Assets */}
        <Grid item xs={12} lg={4}>
          <Assets />
        </Grid>
        {/* Apps */}
        <Grid item xs={12}>
          <Apps />
        </Grid>
      </Grid>
    </>
  )
  // return (
  //   <>
  //     <Grid container spacing={3}>
  //       {supportsRecovery && <RecoveryHeader />}

  //       <Grid item xs={12} lg={6}>
  //         <Overview />
  //       </Grid>

  //       <Grid item xs={12} lg={6}>
  //         <PendingTxsList />
  //       </Grid>

  //       <Grid item xs={12} lg={showRecoveryWidget ? 6 : undefined}>
  //         <FeaturedApps stackedLayout={!!showRecoveryWidget} />
  //       </Grid>

  //       {showRecoveryWidget ? (
  //         <Grid item xs={12} lg={6}>
  //           <RecoveryWidget />
  //         </Grid>
  //       ) : null}

  //       <Grid item xs={12}>
  //         <GovernanceSection />
  //       </Grid>

  //       <Grid item xs={12}>
  //         <SafeAppsDashboardSection />
  //       </Grid>
  //     </Grid>
  //     {showCreationModal ? <CreationDialog /> : null}
  //   </>
  // )
}

export default Dashboard
